import { faHeart } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
    HeartIcon as SourceHeartIcon
} from 'SourceComponent/HeartIcon/HeartIcon.component';

import './HeartIcon.override.style';

/** @namespace Elganso/Component/HeartIcon/Component */
export class HeartIconComponent extends SourceHeartIcon {
    render() {
        return (
            <FontAwesomeIcon icon={ faHeart } />
        );
    }
}

export default HeartIconComponent;
